<zq-tab-group (currentTabLabelChange)="tabChangeHandler($event)" [currentTabLabel]="currentTab | async"
    [emptyDefault]="true">
    <zq-tab label="zones" name="Zones" [templateRef]="zones">
        <ng-template #zones>
            <zq-tab-group [emptyDefault]="true" [currentTabLabel]="currentSubTab | async"
                (currentTabLabelChange)="subTabChangeHandler($event)">
                <zq-tab label="general" name="General" [templateRef]="zonesGeneral">
                    <ng-template #zonesGeneral>
                        <app-table-with-sections [currentTab]="currentTab | async"
                            [type]="tableType.CALIBRATION_GENERAL"
                            [showRequiredFieldsSwitch]="true"></app-table-with-sections>
                    </ng-template>
                </zq-tab>
                <zq-tab label="uses" name="Uses" [templateRef]="zonesUses">
                    <ng-template #zonesUses>
                        <zones-uses [currentTab]="currentTab | async"></zones-uses>
                    </ng-template>
                </zq-tab>
                <zq-tab label="parking" name="Parking" [templateRef]="zonesParking">
                    <ng-template #zonesParking>
                        <zones-table [currentTab]="currentTab | async" [type]="tableType.CALIBRATION_PARKING">
                        </zones-table>
                    </ng-template>
                </zq-tab>
                <zq-tab label="use-capacity" name="Use Capacity" [templateRef]="zonesUseCapacity">
                    <ng-template #zonesUseCapacity>
                        <app-table-with-sections [currentTab]="currentTab | async"
                            [type]="tableType.CALIBRATION_USE_CAPACITY"></app-table-with-sections>
                    </ng-template>
                </zq-tab>
                <zq-tab label="bonus" name="Bonus" [templateRef]="zonesBonus">
                    <ng-template #zonesBonus>
                        <zones-table [currentTab]="currentTab | async" [type]="tableType.CALIBRATION_BONUS">
                        </zones-table>
                    </ng-template>
                </zq-tab>
                <zq-tab label="building-typology" name="Building Typology" [templateRef]="buildingTypology">
                    <ng-template #buildingTypology>
                        <app-zones-building-typology [currentTab]="currentTab | async">
                        </app-zones-building-typology>
                    </ng-template>
                </zq-tab>
            </zq-tab-group>
        </ng-template>
    </zq-tab>
    <zq-tab label="overlays" name="Overlays" [templateRef]="overlays">
        <ng-template #overlays>
            <zq-tab-group [emptyDefault]="true" [currentTabLabel]="currentSubTab | async"
                (currentTabLabelChange)="subTabChangeHandler($event)">
                <zq-tab label="general" name="General" [templateRef]="overlayGeneral">
                    <ng-template #overlayGeneral>
                        <app-table-with-sections [currentTab]="currentTab | async"
                            [type]="tableType.CALIBRATION_GENERAL"></app-table-with-sections>
                    </ng-template>
                </zq-tab>
                <zq-tab label="uses" name="Uses" [templateRef]="overlayUses">
                    <ng-template #overlayUses>
                        <zones-uses [currentTab]="currentTab | async"></zones-uses>
                    </ng-template>
                </zq-tab>
                <zq-tab label="parking" name="Parking" [templateRef]="overlaysParking">
                    <ng-template #overlaysParking>
                        <zones-table [currentTab]="currentTab | async" [type]="tableType.CALIBRATION_PARKING">
                        </zones-table>
                    </ng-template>
                </zq-tab>
                <zq-tab label="use-capacity" name="Use Capacity" [templateRef]="overlaysUseCapacity">
                    <ng-template #overlaysUseCapacity>
                        <app-table-with-sections [currentTab]="currentTab | async"
                            [type]="tableType.CALIBRATION_USE_CAPACITY"></app-table-with-sections>
                    </ng-template>
                </zq-tab>
                <zq-tab label="bonus" name="Bonus" [templateRef]="zonesBonus">
                    <ng-template #zonesBonus>
                        <zones-table [currentTab]="currentTab | async" [type]="tableType.CALIBRATION_BONUS">
                        </zones-table>
                    </ng-template>
                </zq-tab>
                <zq-tab label="building-typology" name="Building Typology" [templateRef]="buildingTypology">
                    <ng-template #buildingTypology>
                        <overlay-typology [currentTab]="currentTab | async">
                        </overlay-typology>
                    </ng-template>
                </zq-tab>
            </zq-tab-group>
        </ng-template>
    </zq-tab>
    <zq-tab label="typologies" name="Typologies" [templateRef]="typologies">
        <ng-template #typologies>
            <zq-tab-group [emptyDefault]="true" [currentTabLabel]="currentSubTab | async"
                (currentTabLabelChange)="subTabChangeHandler($event)">
                <zq-tab label="general" name="General" [templateRef]="typologyGeneral">
                    <ng-template #typologyGeneral>
                        <app-table-with-sections [currentTab]="currentTab | async"
                            [type]="tableType.CALIBRATION_GENERAL"></app-table-with-sections>
                    </ng-template>
                </zq-tab>
                <zq-tab label="uses" name="Uses" [templateRef]="typologyUses">
                    <ng-template #typologyUses>
                        <zones-uses [currentTab]="currentTab | async"></zones-uses>
                    </ng-template>
                </zq-tab>
                <zq-tab label="parking" name="Parking" [templateRef]="typologyParking">
                    <ng-template #typologyParking>
                        <zones-table [currentTab]="currentTab | async" [type]="tableType.CALIBRATION_PARKING">
                        </zones-table>
                    </ng-template>
                </zq-tab>
                <zq-tab label="use-capacity" name="Use Capacity" [templateRef]="typologyUseCapacity">
                    <ng-template #typologyUseCapacity>
                        <app-table-with-sections [currentTab]="currentTab | async"
                            [type]="tableType.CALIBRATION_USE_CAPACITY"></app-table-with-sections>
                    </ng-template>
                </zq-tab>
                <zq-tab label="bonus" name="Bonus" [templateRef]="zonesBonus">
                    <ng-template #zonesBonus>
                        <zones-table [currentTab]="currentTab | async" [type]="tableType.CALIBRATION_BONUS">
                        </zones-table>
                    </ng-template>
                </zq-tab>
            </zq-tab-group>
        </ng-template>
    </zq-tab>
</zq-tab-group>

<ziq-footer class="footer" [entityTab]="currentTab | async" [calibrationTab]="currentSubTab | async"></ziq-footer>
